// extracted by mini-css-extract-plugin
export default {"tableContainer":"AddDesignation_tableContainer__07CGY","resetBtn":"AddDesignation_resetBtn__-kIMn","saveBtn":"AddDesignation_saveBtn__qQ4nD"};